/*eslint-disable*/ module.exports = {
  messages: {
    Active: 'Active',
    Add: 'Add',
    'Add New dish': 'Add New dish',
    'Add New item': 'Add New item',
    'Add Picture': 'Add Picture',
    'Add QR code': 'Add QR code',
    'Add category or element': 'Add category or element',
    'Add dish': 'Add dish',
    'Add new menu': 'Add new menu',
    'After creating a category, you can add dishes.':
      'After creating a category, you can add dishes.',
    All: 'All',
    'All languages': 'All languages',
    Allergens: 'Allergens',
    'Are you sure you want to delete this menu?':
      'Are you sure you want to delete this menu?',
    'Back to Food Menu': 'Back',
    'Beer servings': 'Beer servings',
    Bottom: 'Bottom',
    'Brand elements': 'Brand elements',
    Cancel: 'Cancel',
    Categories: 'Categories',
    'Create Text Block': 'Create Text Block',
    Currency: 'Currency',
    'Daily Menu': 'Daily Menu',
    'Daily menu': 'Daily menu',
    Data: 'Data',
    'Data & Elements': 'Data & Elements',
    Delete: 'Delete',
    'Delete menu': 'Delete menu',
    'Delete page break': 'Delete page break',
    Description: 'Description',
    'Description (Optional)': 'Description (Optional)',
    Designs: 'Designs',
    Duplicate: 'Duplicate',
    'Duplicate menu': 'Duplicate menu',
    Edit: 'Edit',
    'Edit Picture': 'Edit Picture',
    'Edit QR code': 'Edit QR code',
    'Edit Text Block': 'Edit Text Block',
    'Edit dish': 'Edit dish',
    'Edit Star Of The Crafters': 'Edit The Brewers Star - BW',
    'Edit Colored Star Of The Crafters': 'Edit The Brewers Star - color',
    Elements: 'Elements',
    'Error!': 'Error!',
    Export: 'Export',
    'Export XML': 'Export XML',
    'Export PDF': 'Export as PDF',
    'Food cards & Specials': 'Food cards & Specials',
    'Food image': 'Food image',
    'Generate QR code': 'Generate QR code',
    Grid: 'Grid',
    'Hover over the tab area to see options for adding categories and elements.':
      'Hover over the tab area to see options for adding categories and elements.',
    'Hviezda sladkov': 'The Brewers Star - BW',
    'Farebna hviezda sladkov': 'The Brewers Star - color',
    Inline: 'Inline',
    List: 'List',
    Logo: 'Logo',
    'Move Block': 'Move Block',
    'Move after block': 'Move after block',
    'Move block position': 'Move block position',
    'Move to beginning': 'Move to beginning',
    'Name of Restaurant': 'Name of Restaurant',
    'Name of category': 'Name of category',
    'category/element': 'category/element',
    Next: 'Next',
    'No menus were found. Please try to change filters.':
      'No menus were found. Please try to change filters.',
    'One column': 'One column',
    'One column with image': 'One column with image',
    Others: 'Others',
    'Page break': 'Page break',
    Picture: 'Picture',
    Position: 'Position',
    Price: 'Price',
    Primary: 'Primary',
    'Secondary Primary': 'Primary',
    Print: 'Print',
    'QR code': 'QR code',
    Remove: 'Remove',
    'Remove category': 'Remove category',
    'Remove dish': 'Remove dish',
    'Required field': 'Required field',
    Save: 'Save',
    'Select allergens': 'Select allergens',
    'Set to active': 'Set to active',
    'Set to inactive': 'Set to inactive',
    Settings: 'Settings',
    Share: 'Share',
    'Share on FB': 'Share on FB',
    'Copy menu link': 'Copy menu link',
    'Show Allergens': 'Show Allergens',
    'Show Title Page': 'Show Title Page',
    'Show info': 'Show info',
    'Show name of Restaurant': 'Show name of Restaurant',
    'Show text': 'Show text',
    'Show weight / bulk / pieces': 'Show weight / bulk / pieces',
    Size: 'Size',
    'Secondary Size': 'Size',
    Templates: 'Templates',
    'Text block': 'Text block',
    'Tips & Tricks': 'Tips & Tricks',
    Title: 'Title',
    'Two columns': 'Two columns',
    'Two columns with image': 'Two columns with image',
    'Type or choose category': 'Type or choose category',
    'Type or choose dish': 'Type or choose dish',
    'URL address': 'URL address',
    Untitled: 'Untitled',
    'Upload image': 'Upload image',
    'Weight / bulk / pcs': 'Weight / bulk / pcs',
    add: 'add',
    description: 'description',
    languange: 'languange',
    logo: 'logo',
    'remove page': 'remove page',
    units: 'units',
    'Secondary Menu': 'Menu',
    'Secondary Other': 'Other',
    'Logo (Not available)': 'Logo (Not available)',
    "Can't upload image": "Can't upload image",
    'Description not available': 'Description not available',
    'Edit Beer Selection': 'Edit Beer Selection',
    'Add Beer Selection': 'Add Beer Selection',
    'Add Star Of The Crafters': 'Add The Brewers Star - BW',
    'Add Colored Star Of The Crafters': 'Add The Brewers Star - color',
    'Title is required': 'Title is required',
    'size in cl': 'size in cl',
    'size in ml': 'size in ml',
    'Select beers': 'Select Beers',
    Image: 'Image',
    'not available': 'not available',
    'Copied successfully!': 'Copied successfully!',
    'Error copied!': 'Error copied!',
    'Separate price for each item': 'Separate price for each item',
    'Soup price is included in menu': 'Soup price is included in menu',
    'Different price for whole menu': 'Different price for whole menu',
    'Responsibility Message': 'Responsibility Message',
    'ID:': 'ID',
    'Please complete the first 2 steps': 'Please complete the first 2 steps',
    'Image generation in progress. Please wait. When the download is complete, return to the list of daily menus.':
      'Image generation in progress. Please wait. When the download is complete, return to the list of daily menus.',
    'Are you sure you want to delete this category?':
      'Are you sure you want to delete this category?',
    Yes: 'Yes',
    No: 'No',
    'Delete item': 'Delete item',
    'Edit element': 'Edit element',
    'Write a name': 'Write a name',
    'This category already exists.': 'This category already exists.',
    'Something went wrong, probably your file exceeds the allowed post-processing size 10Mb. Please try again with a smaller file.':
      'Something went wrong, probably your file exceeds the allowed post-processing size 10Mb. Please try again with a smaller file.',
    'The uploaded file exceeds the maximum allowed size of 10MB. Please upload a smaller file.':
      'The uploaded file exceeds the maximum allowed size of 10MB. Please upload a smaller file.',
    Warning: 'Warning',
    'You might loose some layout settings by this change. Do you wish to continue?':
      'You might loose some layout settings by this change. Do you wish to continue?',
    'Bottom description': 'Bottom description',
    'Logo size': 'Logo size',
    Small: 'Small',
    Medium: 'Medium',
    Large: 'Large',
  },
}
